var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDeconnexion = function SvgIconDeconnexion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-deconnexion",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "area",
    fill: "#ebebeb",
    opacity: 0.004,
    d: "M0 0h18v18H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M361.279 139.153a.5.5 0 0 0-.854.354v2.293h-4.5a1 1 0 0 0 0 2h4.5v2.293a.5.5 0 0 0 .854.354l3.646-3.647Z",
    transform: "translate(-346.928 -135.799)",
    fill: "#f66969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M358.928 139.833V136.8a1 1 0 0 0-1-1h-10a1 1 0 0 0-1 1v12a.986.986 0 0 0 .5.847v.023l5.465 4.052a.335.335 0 0 0 .535-.27V149.8h4.5a1 1 0 0 0 1-1v-3.033h-2v2.033h-3.5v-7.35a.43.43 0 0 0-.174-.346l-3.108-2.305h6.783v2.034Z",
    transform: "translate(-346.928 -135.799)",
    fill: "#b7b7b7"
  }))));
};
export { SvgIconDeconnexion as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1kZWNvbm5leGlvbiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCI+CiAgPHJlY3QgaWQ9ImFyZWEiIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSIgZmlsbD0iI2ViZWJlYiIgb3BhY2l0eT0iMC4wMDQiLz4KICA8ZyBpZD0iaWNvbiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSI+CiAgICA8cGF0aCBpZD0iUGF0aF84NyIgZGF0YS1uYW1lPSJQYXRoIDg3IiBkPSJNMzYxLjI3OSwxMzkuMTUzYS41LjUsMCwwLDAtLjg1NC4zNTRWMTQxLjhoLTQuNWExLDEsMCwwLDAsMCwyaDQuNXYyLjI5M2EuNS41LDAsMCwwLC44NTQuMzU0bDMuNjQ2LTMuNjQ3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM0Ni45MjggLTEzNS43OTkpIiBmaWxsPSIjZjY2OTY5Ii8+CiAgICA8cGF0aCBpZD0iUGF0aF84OCIgZGF0YS1uYW1lPSJQYXRoIDg4IiBkPSJNMzU4LjkyOCwxMzkuODMzVjEzNi44YTEsMSwwLDAsMC0xLTFoLTEwYTEsMSwwLDAsMC0xLDF2MTJhLjk4Ni45ODYsMCwwLDAsLjUuODQ3di4wMjNsNS40NjUsNC4wNTJhLjMzNS4zMzUsMCwwLDAsLjUzNS0uMjdWMTQ5LjhoNC41YTEsMSwwLDAsMCwxLTF2LTMuMDMzaC0yVjE0Ny44aC0zLjVWMTQwLjQ1YS40My40MywwLDAsMC0uMTc0LS4zNDZsLTMuMTA4LTIuMzA1aDYuNzgzdjIuMDM0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM0Ni45MjggLTEzNS43OTkpIiBmaWxsPSIjYjdiN2I3Ii8+CiAgPC9nPgo8L3N2Zz4K";